import { MilestoneSetsLibrary } from '@/components/milestones/MilestoneSetsLibrary';

export default function AdminMilestoneSetsPage() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <MilestoneSetsLibrary isAdminView={true} />
    </div>
  );
}
